<template>
  <li>
    <div class="card card-service">
      <div class="card-service-title">
        <h4 class="title"><a :href="serviceDetails.getUrl()">{{ capitalizeFirstLetter(serviceDetails.getName()) }}</a></h4>
        <div v-if="mode" class="service-mode">{{ capitalizeFirstLetter(mode) }}</div>
      </div>
      <ul class="resetul">
        <li v-if="serviceDetails.getSupportedMode() || serviceDetails.getServiceKind()">
          <p class="info">
            <i class="icon icon-home" aria-hidden="true"></i>
            <span>
              <span v-if="serviceDetails.getSupportedMode()">
                {{ serviceDetails.getSupportedMode() }}
              </span>
              <br v-if="serviceDetails.getSupportedMode() && serviceDetails.getServiceKind()"/>
              <span v-if="serviceDetails.getServiceKind()">
                {{ serviceDetails.getServiceKind() }}
              </span>
            </span>
          </p>
        </li>
        <li v-if="serviceDetails.getOrganization()">
          <p class="info organization">
            <span class="sr-only">Organisation</span>
            <i class="icon icon-cards_organisation" aria-hidden="true"></i>
            {{ serviceDetails.getOrganization() }}
          </p>
        </li>
        <li v-if="serviceDetails.getSupportedPublic()">
          <p class="info public">
            <span class="sr-only">Public</span>
            <i class="icon icon-cards_public" aria-hidden="true"></i>
            {{ serviceDetails.getSupportedPublic() }}
          </p>
        </li>
        <li v-if="unitType">
          <p class="info type">
            <span class="sr-only">Activités</span>
            <i class="icon icon-cards_activites" aria-hidden="true"></i>
            <span>
              {{ unitType }}
              <span v-if="restrictUnitType">...<button class="btn-nude" :aria-label="PhonebookTranslate.services.button_display_more" type="button" @click="displayAllUnitType">+{{totalUnitType - 3}}</button></span>
            </span>
          </p>
        </li>
        <li v-if="serviceDetails.getPatientele()">
          <p class="info patientele">
            <span class="sr-only">Patientèle</span>
            <i class="icon icon-user-nc" aria-hidden="true"></i>
            {{ serviceDetails.getPatientele() }}
          </p>
        </li>
        <li v-if="serviceDetails.getPhones().length">
          <p class="info phone">
            <span class="sr-only">Téléphone</span>
            <i class="icon icon-cards-phone" aria-hidden="true"></i>
             <span class="numbers-container">
                <span v-for="phone in serviceDetails.getPhones()" :key="phone" >
                  <a :href="`tel:${phone.replaceAll(' ', '')}`" class="btn-phone" :aria-label="`Appeler le ${phone}`">
                    {{ phone }}
                  </a>
                </span>
             </span>
          </p>
        </li>
        <li v-if="serviceDetails.getActiveLabels().length">
          <p class="info">
            <i class="icon icon-cards_label" aria-hidden="true"></i>
            <ul class="resetul">
              <li v-for="(label, i) in serviceDetails.getActiveLabels()" :key="i">
              {{label.name}}
            </li>
            </ul>
          </p>
        </li>
      </ul>
    </div>
  </li>
</template>
<script>
import { computed, ref } from 'vue';
import { ServiceContentModel } from '@/models';
import { capitalizeFirstLetter } from '@/helpers';
import { PhonebookTranslate } from '@/services';

export default {
  props: {
    serviceDetails: {
      type: ServiceContentModel,
      default: () => new ServiceContentModel(),
    },
    mode: {
      type: String,
      default: '',
    },
    maxUnitType: {
      type: Number,
      default: 3,
    },
  },
  setup(props) {
    const totalUnitType = props.serviceDetails.getUnitTypeArray().length;
    const restrictUnitType = ref(totalUnitType > props.maxUnitType);
    const unitType = computed(() => {
      const unitTypeArray = props.serviceDetails.getUnitTypeArray();
      if (restrictUnitType.value) {
        return unitTypeArray.slice(0, props.maxUnitType).join(' | ');
      }
      return unitTypeArray.join(' | ');
    });

    function displayAllUnitType() {
      restrictUnitType.value = false;
    }

    return {
      capitalizeFirstLetter,
      displayAllUnitType,
      restrictUnitType,
      totalUnitType,
      unitType,
      PhonebookTranslate,
    };
  },
};
</script>
